import CardGrid from '../../../components/CardGrid';
import UserCard from '../../../components/UserCard';

function CardBody({ data }) {
  const renderCard = (item, index) => (
    <UserCard
      key={index}
      userId={item?.id}
      userName={item?.username}
      avatarUrl={`https://cdn.stealthisnft.xyz/u/${item?.id}/profile/avatar.jpg`}
      bannerUrl={`https://cdn.stealthisnft.xyz/u/${item?.id}/profile/banner.jpg`}
      bio={item?.bio}
      role={item?.role}
      showFollowButton={true}
    />
  );

  return <CardGrid data={data} renderCard={renderCard} />;
}

export default CardBody;
